






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Resolve } from 'vue-di';
import { Prop } from 'vue-property-decorator';
import { Title } from '~/decorators/Title';
import ColorPicker from '~/components/configuration/ColorPicker.vue'

@Component<ColorSelection>({
    layout: 'default',
    components: {
        ColorPicker,
    },
})
export default class ColorSelection extends Vue {
    @Prop()
    public icon: any;
}
